export default __webpack_public_path__ + "static/media/kitchen5-afterC-1440w.3999a332.webp";